import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Alert, TextField } from '@mui/material';
import styled from '@emotion/styled';
import { updateUser } from 'APIs/AuthApi';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { lg: '700px', xs: '300px' },
  border: '2px solid #DDB930',
  boxShadow: 24,
  p: 4,
  backgroundColor: '#292739',
  borderRadius: '20px',
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
};

type Props = {
  children: any;
  userId?: number;
};

const CssTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: '#DDB930',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#fff',
  },
  '& .MuiInput-underline:before': {
    borderBottomColor: '#DDB930',
  },
  '&:hover fieldset': {
    borderColor: '#DDB930',
  },
  '& .MuiOutlinedInput-root': {
    '&:hover fieldset': {
      borderColor: '#fff',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#DDB930',
    },
  },
  '& .MuiInputBase-input': {
    color: 'white',
    padding: '10px',
    width: '100%',
  },
});

const EditBackstageDescModal = (props: Props) => {
  const [open, setOpen] = React.useState(false);
  const [description, setDescription] = React.useState<string>();
  const [success, setSuccess] = React.useState<boolean>(false);
  const [failure, setFailure] = React.useState<boolean>(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const onSubmit = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    try {
      await updateUser({ id: props.userId, backstageDesc: description });
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
      }, 10000);
    } catch (error) {
      setFailure(true);
      setTimeout(() => {
        setFailure(false);
      }, 10000);
      console.log(error);
    }
  };

  return (
    <div>
      <span
        role="button"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '5px',
          cursor: 'pointer',
        }}
        onClick={handleOpen}
      >
        {props.children}
      </span>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography sx={{ fontSize: 21, color: 'white' }} variant="h2">
            Edit your backstage description
          </Typography>
          <form
            onSubmit={onSubmit}
            style={{ display: 'flex', flexDirection: 'column' }}
          >
            <CssTextField
              placeholder="Description..."
              multiline
              minRows={4}
              margin="dense"
              variant="standard"
              onChange={e => setDescription(e.target.value)}
              required={true}
              inputProps={{ maxLength: 150 }}
            />
            <Button
              sx={{
                backgroundColor: '#DDB930',
                color: 'white',
                marginTop: 2,
                padding: '10px 20px',
                borderRadius: '20px',
                fontWeight: 800,
                textTransform: 'capitalize',
                width: 'fit-content',
              }}
              type="submit"
            >
              Submit
            </Button>
          </form>
          {success && (
            <Alert severity="success">
              Description successfully updated! please reload to see the
              changes.
            </Alert>
          )}
          {failure && (
            <Alert severity="error">Description could not be updated!</Alert>
          )}
        </Box>
      </Modal>
    </div>
  );
};

export default EditBackstageDescModal;
